import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import { formFieldProps } from 'utils/form'
import { createValidationSchema, optional } from 'utils/validations'
import { UIButton } from 'components/ui/Button'
import { useState } from 'react'
import { showSuccessToast } from 'utils/toast'
import { closeTicket } from 'api/tickets'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'components/ui/Modal'
import { TextArea } from 'components/ui/TextArea'
import { useModal } from 'providers/ModalProvider'

type CloseTicketModalProps = {
  onSuccess?: () => void
  ticketId: string
}

export const CloseTicketModal = ({ onSuccess, ticketId }: CloseTicketModalProps) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const { close } = useModal()

  const { values, errors, setFieldValue, setFieldError, handleSubmit } = useFormik({
    initialValues: {
      closingReason: '',
    },
    validationSchema: createValidationSchema({
      closingReason: optional,
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      console.debug({ values })
      try {
        setLoading(true)
        await closeTicket(ticketId, values.closingReason)
        onSuccess?.()
        showSuccessToast(t('tickets.closedSuccess'))
        close()
      } catch (e) {
        console.error({ e })
      } finally {
        setLoading(false)
      }
    },
  })

  const fieldProps = formFieldProps(errors, values, setFieldError, setFieldValue)

  return (
    <Modal onClose={close}>
      <ModalHeader title={t('closeTicket')} icon="circle-check" />
      <ModalBody className={'tw-space-y-1'}>
        <TextArea label={t('tickets.closingReason')} {...fieldProps('closingReason')} />
      </ModalBody>
      <ModalFooter>
        <UIButton className={'tw-w-full'} onClick={() => handleSubmit()} loading={loading}>
          <span className={'tw-text-sm'}>{t('closeTicket')}</span>
        </UIButton>
      </ModalFooter>
    </Modal>
  )
}
